import { Component, Input, OnDestroy } from '@angular/core';

import { WindowService } from '@core/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { PreferencesService } from '../../../preferences/preferences-service/preferences.service';
import { TReminder } from '../../../reminders/reminders.consts';
import { UserService } from '../../../user/user.service';
import { generateTimeText } from '../../utils/generate-time-text';
import { PointReminderModalService } from '../point-reminder-modal/point-reminder-modal.service';

@Component({
  selector: 'pp-point-reminder',
  templateUrl: './point-reminder.component.html',
  styleUrls: ['./point-reminder.component.scss'],
  standalone: false,
})
export class PointReminderComponent implements OnDestroy {
  @Input() ppReminder: TReminder;
  reminderDueTime = '';
  reminderSnoozeTime = '';

  isOverdue = false;
  isDismissed = false;
  isSnoozed = false;
  createdForMe = false;
  createdForOthers = false;

  refreshInterval: any;
  EIconPath = EIconPath;
  showSnoozeTooltip: boolean;
  private intervalStep = 60000;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private preferencesService: PreferencesService,
    private windowService: WindowService,
    private pointReminderModalService: PointReminderModalService,
    private userService: UserService,
  ) {
    this.windowService.resize$.pipe(takeUntil(this.destroy$)).subscribe((dimensions) => {
      this.showSnoozeTooltip = dimensions.innerWidth <= 520;
    });
  }

  ngOnInit(): void {
    this.setDisplayData();

    this.refreshInterval = setInterval(() => {
      this.setDisplayData();
    }, this.intervalStep);
  }

  ngOnDestroy(): void {
    clearInterval(this.refreshInterval);
    this.destroy$.next();
  }

  viewReminder(): void {
    this.pointReminderModalService.showReminderModal({
      reminder: this.ppReminder,
    });
  }

  private isReminderOverdue(): boolean {
    const now = new Date().getTime();

    return now > this.ppReminder.timestampEpochMillis && !this.ppReminder.dismissed;
  }

  private isReminderSnoozed(): boolean {
    return (
      this.ppReminder.alertEpochMillis !== this.ppReminder.timestampEpochMillis &&
      !this.ppReminder.dismissed
    );
  }

  private setDisplayData(): void {
    const dateFormat = this.preferencesService.getPreferences().dateFormat;
    const user = this.userService.getUser();

    this.reminderDueTime = generateTimeText(this.ppReminder.timestampEpochMillis, dateFormat);
    this.isDismissed = this.ppReminder.dismissed;

    this.isOverdue = this.isReminderOverdue();
    this.isSnoozed = this.isReminderSnoozed();

    if (this.isSnoozed) {
      this.reminderSnoozeTime = generateTimeText(this.ppReminder.alertEpochMillis, dateFormat);
    }

    this.createdForMe = this.ppReminder.targetUserId !== user.userId;
    this.createdForOthers =
      this.ppReminder.targetUserId === user.userId && this.ppReminder.assignees?.length > 0;
  }
}
